import { useEffect, useMemo } from 'react';
import { QueryKey, useQueryClient } from 'react-query';

export const useDebouncedInvalidate = (queryKey: QueryKey, delayMs = 300) => {
  const queryClient = useQueryClient();

  const schedule = useMemo(() => {
    let t: ReturnType<typeof setTimeout> | null = null;

    const fn = () => {
      if (t) clearTimeout(t);
      t = setTimeout(() => {
        queryClient.invalidateQueries({ queryKey });
        t = null;
      }, delayMs);
    };

    fn.cancel = () => {
      if (t) clearTimeout(t);
      t = null;
    };

    return fn;
  }, [queryClient, delayMs, queryKey]);

  useEffect(() => () => schedule.cancel(), [schedule]);

  return schedule as (() => void) & { cancel: () => void };
};
